import { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';

interface CopyableTextProps {
  value: string | null;
  label: string;
  fallback?: string;
  toast?: React.RefObject<Toast>;
}

const CopyableText = ({ value, label, fallback = '—', toast: externalToast }: CopyableTextProps) => {
  const internalToast = useRef<Toast>(null);
  const toastRef = externalToast || internalToast;
  const tooltipId = useRef(`copyable-${Math.random().toString(36).substring(2, 9)}`);

  const handleCopy = () => {
    if (!value) return;
    navigator.clipboard.writeText(value);
    toastRef.current?.show({
      severity: 'success',
      summary: 'Copied',
      detail: `${label} copied to clipboard`,
      life: 3000,
    });
  };

  return (
    <>
      {!externalToast && <Toast ref={internalToast} />}
      {value && <Tooltip target={`.${tooltipId.current}`} content="Copy to clipboard" position="top" />}
      <div
        className={`font-semibold ${value ? `${tooltipId.current} hover:text-primary` : ''}`}
        style={{
          wordBreak: 'break-all',
          cursor: value ? 'pointer' : 'default',
        }}
        onClick={handleCopy}
      >
        {value || fallback}
      </div>
    </>
  );
};

export default CopyableText;
